import { ChargeType } from '@40seas/entities/charges';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const ChargeInvoiceDtoSchema = z.object({
    chargeType: EnumSchema(ChargeType),
});

export class ChargeInvoiceDto extends FromSchema(ChargeInvoiceDtoSchema) {
    chargeType: ChargeType;
}
